// AppConfigContext.tsx
import React, { createContext, useContext, useState, useEffect } from "react";
import { getApplicationConfig } from "../network/apiService";
import { getCookie } from "../utils/cookies";

interface AppConfigContextType {
  config: any;
  loading: boolean;
  error: Error | null;
}

const AppConfigContext = createContext<AppConfigContextType>({
  config: null,
  loading: false,
  error: null
});

export const useAppConfig = () => useContext(AppConfigContext);

export const AppConfigProvider: React.FC<{ children: React.ReactNode }> = ({
  children
}) => {
  const [config, setConfig] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (config === null && getCookie("id_token") && !loading) {
      (async () => {
        try {
          setLoading(true);
          const res: any = await getApplicationConfig();
          setConfig(res?.data ?? {});
        } catch (err: any) {
          setError(err);
        } finally {
          setLoading(false);
        }
      })();
    }
  }, [config]);

  return (
    <AppConfigContext.Provider value={{ config, loading, error }}>
      {children}
    </AppConfigContext.Provider>
  );
};
